import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import Icon from '../../Icons'
import API from '../../../api/api'
import CollectionItem from '../../Collection/CollectionItem'
import Avatar from '../../../Avatar'

export class OrganisationSKUItem extends Component {
  static propTypes = {
    sku: PropTypes.object.isRequired,
    onEdit: PropTypes.func,
    icon: PropTypes.string,
    color: PropTypes.string,
    isAddPopup: PropTypes.bool,
    clientId: PropTypes.number,
    t: PropTypes.func.isRequired,
  }

  state = {
    isInfoVisible: false,
    msg: '',
  }

  editSku = (e) => {
    e.preventDefault()
    this.props.onEdit(this.props.sku)
  }

  // todo rewrite, move this logic to parent component
  addClientSku(e, sku) {
    const skuId = sku.id
    const clientId = this.props.clientId
    e.preventDefault()
    const { t } = this.props
    API.addOneProduct(clientId, skuId)
      .then(() => {
        this.setState({ isInfoVisible: true, msg: t('organisation:sku.item.added') })
        setTimeout(() => this.setState({ isInfoVisible: false, msg: '' }), 2000)
      })
      .catch(() => {
        this.setState({ isInfoVisible: true, msg: t('organisation:sku.item.error') })
        setTimeout(() => this.setState({ isInfoVisible: false, msg: '' }), 2000)
      })
  }

  render() {
    const { sku, icon, color, isAddPopup, t } = this.props
    const { msg } = this.state
    return (
      <CollectionItem onClick={(e) => e.stopPropagation()} additionalClass="ctp-shop-item">
        {icon && (
          <Avatar background={color}>
            <Icon icon={icon} fill={'white'} />
          </Avatar>
        )}
        <span>{sku.name}</span>
        {isAddPopup ? (
          <button
            className="button button-primary auto-width"
            onClick={(e) => this.addClientSku(e, sku)}
          >
            {t('organisation:shared.actions.add')}
          </button>
        ) : (
          <button className="button button-primary auto-width" onClick={this.editSku}>
            {t('common:actions.edit')}
          </button>
        )}
        {this.state.isInfoVisible && <p className="help is-success">{msg}</p>}
      </CollectionItem>
    )
  }
}

export default withTranslation(['organisation', 'common'])(OrganisationSKUItem)
